<template>
  <section class="page-wrap">
    <filter-search
      :list="filterSearchList"
      :fromdata="formData"
      @Refresh="onHandleRefresh"
      @search="onHandleSearch"
    >
      <template slot="left">
        <el-button type="primary" @click="onHandleCreate">
          新增
        </el-button>
      </template>
      <template slot="right">
        <el-button
          type="warning"
          icon="el-icon-download"
          :disabled="!tableData.length || disabledExport"
          @click="onHandleExport"
          >导出</el-button
        >
      </template>
    </filter-search>

    <section class="summary">
      总退款金额：<strong>{{ refundTotal.toFixed(2) }}</strong> 元
    </section>

    <section class="content">
      <el-table
        v-loading="loadingData"
        :data="tableData"
        height="100%"
        border
        :header-cell-style="{ color: '#333', background: '#EFF6FF' }"
      >
        <el-table-column type="index" label="序号" width="55" align="center" />
        <el-table-column
          prop="supplier_name"
          label="供应商名称"
          min-width="120"
        />
        <el-table-column
          prop="logistic_business_name"
          label="集配中心"
          min-width="120"
        />
        <el-table-column
          prop="create_time"
          label="添加时间"
          width="110"
          align="center"
        />
        <el-table-column
          prop="operate_name"
          label="添加人"
          width="90"
          align="center"
        />
        <el-table-column
          prop="amount"
          label="扣款金额"
          width="90"
          align="center"
        />
        <el-table-column
          prop="check_operate_name"
          label="审核人"
          width="90"
          align="center"
        />
        <el-table-column
          prop="deduction_type_txt"
          label="扣款类型"
          width="100"
          align="center"
        />
        <el-table-column
          prop="as_no"
          label="售后单号"
          min-width="130"
          align="center"
        />
        <el-table-column
          prop="order_no"
          label="订单号"
          min-width="120"
          align="center"
        />
        <el-table-column prop="title" label="商品名称" min-width="110" />
        <el-table-column
          prop="trade_no"
          label="退款流水号"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="deduction_state_txt"
          label="扣款状态"
          width="90"
          align="center"
        />
        <el-table-column
          prop="check_state_txt"
          label="审核状态"
          width="90"
          align="center"
        />
        <el-table-column
          prop="check_time"
          label="扣款时间"
          width="110"
          align="center"
        />
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="onHandleView(scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="scope.row.is_audit == '1'"
              type="text"
              @click="onHandleAudit(scope.row)"
              >审核</el-button
            >
            <el-button
              v-if="scope.row.is_audit == '1'"
              type="text"
              @click="onHandleCancel(scope.row)"
              >作废</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>

    <div class="pagination">
      <el-pagination
        background
        :current-page="formData.page"
        :page-size="formData.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
      />
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      @close="resetDialog"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="dialogForm"
        :model="dialogData"
        :rules="dialogRules"
        label-width="110px"
      >
        <el-form-item label="扣款类型"
          ><el-input value="平台客诉" disabled
        /></el-form-item>
        <el-form-item label="订单号" prop="order_no">
          <el-input
            v-model="dialogData.order_no"
            :disabled="dialogReadonly"
            placeholder="输入订单号"
            @blur="getGoodsList"
          />
        </el-form-item>
        <el-form-item label="商品名称" prop="order_detail_id">
          <el-input
            v-if="dialogReadonly"
            :value="dialogData.title"
            disabled
            placeholder="商品名称"
          />
          <el-select
            v-else
            v-model="dialogData.order_detail_id"
            placeholder="选择商品名称"
            @change="onGoodsChange"
          >
            <el-option
              v-for="item in goodsList"
              :key="item.order_detail_id"
              :label="item.title"
              :value="item.order_detail_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="" v-if="remainInfo"
          ><div class="remain-tip">
            {{ remainInfo }}
          </div></el-form-item
        >
        <el-form-item label="金额" prop="amount"
          ><el-input
            v-model="dialogData.amount"
            :disabled="dialogReadonly"
            type="number"
            placeholder="输入金额"
        /></el-form-item>
        <el-form-item label="备注" prop="remark"
          ><el-input
            v-model="dialogData.remark"
            type="textarea"
            maxlength="200"
            show-word-limit
            :disabled="dialogReadonly"
            placeholder="输入备注"
        /></el-form-item>
        <el-form-item label="相关证明"
          ><b-file-upload
            :accepts="['jpg', 'jpeg', 'png']"
            :limit="5"
            :disabled="dialogReadonly"
            v-model="picList"
        /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-if="!dialogReadonly" type="primary" @click="onHandleSave"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>

<script>
import BFileUpload from "@/components/business/BFileUpload/index.vue";
import FilterSearch from "@/components/Filtersearch.vue";
import {
  getAfterSaleExtendList,
  postAfterSaleExtendAdd,
  postAfterSaleExtendCheck,
  getAfterSaleExtendRemain,
  getfloworderdetail,
  getSupplierSelectList,
} from "@/api/general/operation-center/index";
import { postAfterSaleExtendExport } from "@/api/export/center";

export default {
  name: "CustomerComplaint",
  components: { BFileUpload, FilterSearch },
  data() {
    return {
      loadingData: false,
      disabledExport: false,
      formData: {
        logistic_business_id: "",
        supplier_id: "",
        as_no: "",
        order_no: "",
        deduction_state: "",
        check_state: "",
        start_date: "",
        end_date: "",
        deduct_start_date: "",
        deduct_end_date: "",
        createTime: [],
        deductionTime: [],
        trade_no: "",
        operate_name: "",
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      totalAmount: "0.00",

      dialogVisible: false,
      dialogReadonly: true,

      dialogTitle: "",
      dialogData: {},
      dialogRules: {
        order_no: [{ required: true, message: "请输入订单号", trigger: "blur" }],
        order_detail_id: [
          { required: true, message: "请选择商品名称", trigger: "change" },
        ],
        amount: [{ required: true, message: "请输入金额", trigger: "blur"  }],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      goodsList: [],
      remainInfo: null,
      picList: [],
      logisticList: [],
      supplierList: [],
      filterSearchList: [
        {
          name: "集配中心",
          type: "select",
          model: "logistic_business_id",
          placeholder: "集配中心",
          clearable: true,
          filterable: true,
          selectoption: [],
          label: "name",
          value: "id",
        },
        {
          name: "供应商",
          type: "select",
          model: "supplier_id",
          placeholder: "选择供应商",
          clearable: true,
          filterable: true,
          selectoption: [],
          label: "title",
          value: "id",
        },
        {
          name: "售后单号",
          type: "input",
          model: "as_no",
          placeholder: "售后单号",
          clearable: true,
        },
        {
          name: "订单号",
          type: "input",
          model: "order_no",
          placeholder: "订单号",
          clearable: true,
        },
        {
          name: "扣款状态",
          type: "select",
          model: "deduction_state",
          placeholder: "扣款状态",
          clearable: true,
          selectoption: [
            { value: 0, label: "未扣款" },
            { value: 1, label: "已扣款" },
          ],
          label: "label",
          value: "value",
        },
        {
          name: "审核状态",
          type: "select",
          model: "check_state",
          placeholder: "审核状态",
          clearable: true,
          selectoption: [
            { value: 0, label: "未审核" },
            { value: 1, label: "已审核" },
            { value: 2, label: "作废" },
          ],
          label: "label",
          value: "value",
        },
        {
          name: "添加日期",
          type: "daterange",
          model: "createTime",
          startmodel: "start_date",
          endmodel: "end_date",
          startplaceholder: "添加日期起",
          endplaceholder: "添加日期止",
          clearable: true,
          pickerOptions: 1,
        },
        {
          name: "扣款时间",
          type: "daterange",
          model: "deductionTime",
          startmodel: "deduct_start_date",
          endmodel: "deduct_end_date",
          startplaceholder: "扣款时间起",
          endplaceholder: "扣款时间止",
          clearable: true,
        },
        {
          name: "退款流水号",
          type: "input",
          model: "trade_no",
          placeholder: "退款流水号",
          clearable: true,
        },
        {
          name: "添加人",
          type: "input",
          model: "operate_name",
          placeholder: "添加人",
          clearable: true,
        },
      ],
      deductionStateList: [
        { value: 0, label: "未扣款" },
        { value: 1, label: "已扣款" },
      ],
      checkStateList: [
        { value: 0, label: "未审核" },
        { value: 1, label: "已通过" },
        { value: 2, label: "作废" },
      ],
    };
  },
  computed: {
    refundTotal() {
      return Number(this.totalAmount || 0);
    },
  },
  created() {
    this.ajaxGetTableData();
    this.ajaxGetLogisticList();
    this.getAjaxSupplierSelectList();
  },
  methods: {
    async ajaxGetTableData() {
      this.loadingData = true;
      try {
        const { data } = await getAfterSaleExtendList({
          ...this.formData,
        });
        this.tableData = data.data || [];
        this.total = data.total || 0;
        this.totalAmount = data.total_amount || 0;
      } catch (error) {
        console.log("getAfterSaleExtendList error", error);
      } finally {
        this.loadingData = false;
      }
    },
    async ajaxGetLogisticList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.logisticList = data;
        this.filterSearchList[0].selectoption = data;
      } catch (error) {
        console.log("ajax businessList error", error);
      }
    },
    async getAjaxSupplierSelectList() {
      try {
        const { data } = await getSupplierSelectList();
        this.supplierList = data;
        this.filterSearchList[1].selectoption = data;
      } catch (error) {
        console.log("ajax getSupplierSelectList error", error);
      }
    },
    onHandleSearch(data) {
      this.formData = {
        ...this.formData,
        ...data,
        page: 1,
      };
      this.ajaxGetTableData();
    },
    onHandleRefresh() {
      this.formData = {
        logistic_business_id: "",
        supplier_id: "",
        as_no: "",
        order_no: "",
        deduction_state: "",
        check_state: "",
        start_date: "",
        end_date: "",
        deduct_start_date: "",
        deduct_end_date: "",
        createTime: [],
        deductionTime: [],
        trade_no: "",
        operate_name: "",
        page: 1,
        pageSize: 10,
      };
      this.ajaxGetTableData();
    },
    onHandleCreate() {
      this.dialogTitle = "新增";
      this.dialogReadonly = false;
      this.dialogData = { type: 1 };
      this.goodsList = [];
      this.remainInfo = null;
      this.picList = [];
      this.dialogVisible = true;
    },
    onHandleView(row) {
      this.dialogTitle = "查看";
      this.dialogReadonly = true;
      this.dialogData = {
        ...row,
        amount: row.amount || row.deduction_amt,
        title: row.title,
      };
      this.picList = this.toFileList(row.pic);
      this.dialogVisible = true;
    },
    onHandleAudit(row) {
      this.$confirm("审核后立即生效，确认操作？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.onAudit(row.id, 1);
        })
        .catch(() => {});
    },
    // 作废
    onHandleCancel(row) {
      this.$confirm("此条数据即将作废，是否确认？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.onAudit(row.id, 2);
        })
        .catch(() => {});
    },
    async getGoodsList() {
      if (!this.dialogData.order_no) return;
      try {
        const { data } = await getfloworderdetail({
          order_no: this.dialogData.order_no,
        });
        this.goodsList = data.list || [];
      } catch (error) {
        console.log("getfloworderdetail error", error);
      }
    },
    async onGoodsChange(orderDetailId) {
      const goods = this.goodsList.find((item) => item.id === orderDetailId);
      if (goods) this.dialogData.title = goods.title;
      try {
        const { data } = await getAfterSaleExtendRemain({
          order_detail_id: orderDetailId,
        });
        this.remainInfo = data || null;
      } catch (error) {
        console.log("getAfterSaleExtendRemain error", error);
      }
    },
    onHandleSave() {
      this.$refs.dialogForm.validate(async (valid) => {
        if (!valid) return;
        try {
          const res = await postAfterSaleExtendAdd({
            order_no: this.dialogData.order_no,
            order_detail_id: this.dialogData.order_detail_id,
            amount: this.dialogData.amount,
            remark: this.dialogData.remark,
            pic: this.picList.map((item) => item.url || item.name).join(","),
          });
          this.dialogVisible = false;
          await this.ajaxGetTableData();
          this.$message.success(res.msg || "保存成功");
        } catch (error) {
          console.log("postAfterSaleExtendAdd error", error);
        }
      });
    },
    async onAudit(id, check_state) {
      try {
        const res = await postAfterSaleExtendCheck({
          id,
          check_state,
        });
        this.$message.success(res.msg || (check_state === 2 ? "作废成功" : "审核成功"));
        this.ajaxGetTableData();
      } catch (error) {
        console.log("postAfterSaleExtendCheck error", error);
      }
    },
    toFileList(pic) {
      return pic
        ? String(pic)
            .split(",")
            .map((url) => ({ name: url, url }))
        : [];
    },
    resetDialog() {
      this.dialogData = {};
      this.goodsList = [];
      this.remainInfo = null;
      this.picList = [];
      this.$refs.dialogForm.resetFields();
    },
    async onHandleExport() {
      this.disabledExport = true;
      try {
        await postAfterSaleExtendExport({ ...this.formData });
        this.$message.success("导出任务已提交");
        this.goExportCenter();
      } catch (error) {
        console.log("postAfterSaleExtendExport error", error);
      } finally {
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    onHandleSizeChange(value) {
      this.formData.page = 1;
      this.formData.pageSize = value;
      this.ajaxGetTableData();
    },
    onHandleCurrentChange(value) {
      this.formData.page = value;
      this.ajaxGetTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  margin: 8px;
  background: #fff;
}
.summary {
  padding: 0 20px 8px;
  text-align: right;
  color: #333;
  font-size: 13px;
}
.summary strong {
  color: #333;
}
.content {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.remain-tip {
  color: #ff4a4a;
  font-size: 12px;
}
.pagination {
  padding: 10px 20px 0;
}
</style>
